import type { EvolutionAttachedPrintable } from './evolutionWorkflowTypes';

/**
 * Monta lote para «Imprimir todos»: impressos + indicações (seção separada na evolução).
 * `indicationAttachment` traz grade oftalmológica / texto livre com observações.
 */
export function buildEvolutionPrintBatch(
  attachedPrintables: EvolutionAttachedPrintable[],
  procedureLabels: string[],
  indicationAttachment?: EvolutionAttachedPrintable | null,
): EvolutionAttachedPrintable[] {
  const items = attachedPrintables.filter((p) => p.category !== 'indication');
  const indicationBody = String(indicationAttachment?.bodyText || '').trim();
  if (indicationBody) {
    items.push(
      indicationAttachment || {
        clientKey: `evolution-batch-indication:${crypto.randomUUID()}`,
        category: 'indication',
        templateName: 'Indicações',
        bodyText: indicationBody,
      },
    );
  } else {
    const trimmed = procedureLabels.map((l) => String(l || '').trim()).filter(Boolean);
    if (trimmed.length > 0) {
      items.push({
        clientKey: `evolution-batch-indication-labels:${crypto.randomUUID()}`,
        category: 'indication',
        templateName: 'Indicações',
        bodyText: ['INDICAÇÕES', '', ...trimmed.map((l) => `• ${l}`)].join('\n'),
      });
    }
  }
  return items;
}

export function evolutionHasPrintBatchContent(
  attachedPrintables: EvolutionAttachedPrintable[],
  procedureLabels: string[],
  indicationAttachment?: EvolutionAttachedPrintable | null,
): boolean {
  if (attachedPrintables.some((p) => p.category !== 'indication')) return true;
  if (String(indicationAttachment?.bodyText || '').trim()) return true;
  return procedureLabels.some((l) => String(l || '').trim().length > 0);
}
